import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const markFormAsPublish = async (payload: Partial<IAdminObservationForm>) => {
	const url = `/observations/admin/forms/${payload.id}/`;

	const response = await cmsClient.patch<IFormInstance>(url, payload);
	return response.data;
};

const useMutatePublishForm = () => {
	const mutation = useMutation(markFormAsPublish);

	return mutation;
};

export default useMutatePublishForm;
